import { SupplierListItem } from '../SupplierListItem/SupplierListItem';
import { SourcingProjectSupplierData } from '~/common/types/cubes/SourcingProjectSupplier';

import { StyledList } from './SupplierList.styled';

export interface SupplierListProps {
  sourcingProjectSuppliers: SourcingProjectSupplierData[];
  hasMore?: boolean;
}

export const SupplierList = ({ sourcingProjectSuppliers, hasMore }: SupplierListProps) => {
  return (
    <>
      <StyledList length={sourcingProjectSuppliers.length} hasMore={hasMore} disablePadding>
        {sourcingProjectSuppliers.map((supplier) => (
          <SupplierListItem key={supplier.supplierId} {...supplier} />
        ))}
      </StyledList>
    </>
  );
};
